import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import LoginPage from './components/LoginPage';
import { login } from './redux/slice';

const Login = () => {
  const { loading } = useSelector((state) => state.login);
  const dispatch = useDispatch();

  const [isStayLoggedInChecked, setIsStayLoggedInChecked] = useState(0);

  const onSubmit = (payload) => {
    dispatch(login(payload));
  };

  return (
    <>
      <LoginPage
        loading={loading}
        onSubmit={onSubmit}
        isStayLoggedInChecked={isStayLoggedInChecked}
        setIsStayLoggedInChecked={setIsStayLoggedInChecked}
      />
    </>
  );
};

export default Login;
